function stringToNumber(value: string | number): number {
  if (value === null || value === undefined || value === '') {
    return 0;
  }

  if (typeof value === 'number') {
    return value;
  }

  return parseInt(value, 10);
}

function sum(list: number[]): number {
  return list.reduce((a, b) => stringToNumber(a) + stringToNumber(b), 0);
}

function sumBy(list: unknown[], key: string): number {
  return sum(list.map((l) => l[key]));
}

function avg(list: number[]): number {
  return sum(list) / list.length;
}

function avgBy(list: unknown[], key: string): number {
  return avg(list.map((l) => l[key]));
}

function min(list: number[]): number {
  return Math.min(...list);
}

function max(list: number[]): number {
  return Math.max(...list);
}

function minBy(list: unknown[], key: string): number {
  return min(list.map((l) => l[key]));
}

function maxBy(list: unknown[], key: string): number {
  return max(list.map((l) => l[key]));
}

const QuickMathUtils = {
  sum,
  sumBy,
  avg,
  avgBy,
  min,
  minBy,
  max,
  maxBy,
};

export default QuickMathUtils;
